import { prefetchCurrencies, currencies, DEFAULT_CURRENCY } from '@js/core/currencies.js';
import { convert, symbol } from '@js/utils/currencyUtils'; // Import currencyUtils

const popularCurrencies = ['GBP', 'EUR', 'USD'];

export default {
    data() {
        return {
            loadingCurrencies: true,
            currencies,
        };
    },
    computed: {
        orderedCurrencies() {
            return _.keys(this.currencies).sort((currencyA, currencyB) => {
                let compareA = popularCurrencies.indexOf(currencyA) * -1;
                let compareB = popularCurrencies.indexOf(currencyB) * -1;
                if (compareA === compareB) {
                    compareA = currencyA;
                    compareB = currencyB;
                }
                return compareA < compareB ? -1 : 1;
            });
        },
    },
    methods: {
        symbol(currency) {
            // Use currencyUtils for symbol
            return symbol(currency);
        },
        convert(amount, to, from) {
            if (this.loadingCurrencies) {
                return 0;
            }
            // Use currencyUtils for convert
            return convert(amount, to, from);
        },
    },
    created() {
        // This will only send a request once per browser session.
        prefetchCurrencies().then(() => {
            this.loadingCurrencies = false;
            this.currencies = currencies;
        });
    },
};
